import Head from 'next/head';
import {MetaTagsProps} from '@/types';
import {defaultMetaTags} from '@/content';


export const MetaTags = ({
                                     metaTags = defaultMetaTags,
                                 }: { metaTags?: MetaTagsProps }) => {

    const {description, keywords, type, title, url, ogImage} = metaTags || defaultMetaTags;

    return (
        <Head>
            {/* Primary Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta charSet="UTF-8" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={ogImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
            <meta name="twitter:url" content={url} />

            {/* Favicon */}
            <link rel="icon" href="/images/favicon/favicon.ico" />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />
        </Head>
    );
}
